import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateFacilityIds, getConfigurationFacility } from "../../app/store/config/configActions";
import { State } from "../../app/store";
import { getStepSaleConfig } from "../../app/store/stepSaleConfig/saleStepConfigActions";

export function useFacilityIdManager() {
  const dispatch = useDispatch();
  const configuration = useSelector((state: State) => state.config.configuration);
  const userData = useSelector((state: State) => state.auth.userData);
  const isB2B = Boolean(userData.b2bType);

  const getFacilityIdFromUrl = () => {
    const queryParams = new URLSearchParams(window.location.search);
    // Najpierw próbujemy standardowego parametru "id"
    let facilityId = queryParams.get("id");

    // Jeśli parametr zawiera "/", pobieramy tylko część przed "/"
    if (facilityId && facilityId.includes("/")) {
      facilityId = facilityId.split("/")[0];
    }

    // Jeśli nie ma "id", sprawdzamy alternatywy
    if (!facilityId) {
      facilityId = queryParams.get("facilityIds") || queryParams.get("facilityId") || queryParams.get("ids");

      // Jeśli parametr jest w formacie "0,1212" - usuwamy "0,"
      if (facilityId && facilityId.startsWith("0,")) {
        facilityId = facilityId.substring(2);
      }

      if (facilityId) {
        // Usuwamy alternatywne parametry
        queryParams.delete("facilityIds");
        queryParams.delete("facilityId");
        queryParams.delete("ids");
        // Ustawiamy parametr "id" z odczytaną (i ewentualnie zmodyfikowaną) wartością
        queryParams.set("id", facilityId);
        const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
        window.history.replaceState({}, "", newUrl);
      }
    }
    return facilityId;
  };

  useEffect(() => {
    const handleFacilityId = async () => {
      try {
        const urlFacilityId = getFacilityIdFromUrl();
        const storedFacilityId = sessionStorage.getItem("facilityId");

        if (urlFacilityId) {
          dispatch(updateFacilityIds(urlFacilityId));
          sessionStorage.setItem("facilityId", urlFacilityId);

          if (!configuration || Object.keys(configuration).length === 0) {
            dispatch(getConfigurationFacility(urlFacilityId));
            dispatch(getStepSaleConfig(urlFacilityId));
          }
        } else if (storedFacilityId) {
          // Jeśli usunięto 'id' z URL, przywracamy go
          const newUrl = new URL(window.location.href);
          newUrl.searchParams.set("id", storedFacilityId);
          window.history.replaceState({}, "", newUrl.toString());
        }
      } catch (error) {
        console.error("Error handling facility ID:", error);
      }
    };

    const checkForIdChange = () => {
      const newFacilityId = getFacilityIdFromUrl() || "";
      const storedFacilityId = sessionStorage.getItem("facilityId");

      if (!storedFacilityId && newFacilityId) {
        sessionStorage.setItem("facilityId", newFacilityId);
      } else if (newFacilityId !== storedFacilityId) {
        sessionStorage.setItem("facilityId", newFacilityId);
        window.location.reload();
      }
    };

    handleFacilityId();

    window.addEventListener("popstate", checkForIdChange);
    window.addEventListener("pushstate", checkForIdChange);
    window.addEventListener("replaceState", checkForIdChange);

    return () => {
      window.removeEventListener("popstate", checkForIdChange);
      window.removeEventListener("pushstate", checkForIdChange);
      window.removeEventListener("replaceState", checkForIdChange);
    };
  }, [dispatch, configuration]);

  useEffect(() => {
    const facilityId = sessionStorage.getItem("facilityId");
    if (facilityId && userData.objectId && isB2B) {
      dispatch(getStepSaleConfig(facilityId));
    }
  }, [dispatch, isB2B, userData.objectId]);
}
